<template>
  <div class="flex flex-wrap">
    <div class="w-full pb-6" v-for="track in tracking">
      <p class="font-bold">{{ track.type }}</p>
      <div class="flex w-full">
        <div class="w-1/3">
          <p>{{ track.status }}</p>
        </div>
        <div class="w-1/3">
          <p>{{ track.time }}</p>
        </div>
        <div class="w-1/3">
          <p>{{ track.ip }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const trackingMock = [
  {
    type: "Documento enviado",
    status: "Enviado",
    time: "11/07/2023 15:13:06 GMT - 03:00",
    ip: "192.168.0.1",
  },
  {
    type: "Documento entregado",
    status: "Visto",
    time: "11/07/2023 15:13:06 GMT - 03:00",
    ip: "192.168.0.1",
  },
  {
    type: "Firmado",
    status: "Firmado",
    time: "11/07/2023 15:13:06 GMT - 03:00",
    ip: "192.168.0.1",
  },
];
export default {
  name: "Tracking",
  data() {
    return {
      tracking: trackingMock,
    };
  },
};
</script>

<style lang="scss" scoped></style>
